import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterSupplySuspensionModel } from "@/core/models/water-supply-suspension.model";

interface _WaterSupplySuspensionGetParams {
    search?: string;
}

@injectable()
export class WaterSupplySuspensionRepo extends TableRepo<WaterSupplySuspensionModel> {
    constructor() {
        super("/api/WaterSupplySuspension");
    }

    async getData(index: number, params: _WaterSupplySuspensionGetParams, pageSize = 10): Promise<ApiPage<WaterSupplySuspensionModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}